
  
  const productos = [
  {
    id: 1,
    categoria: "cat-8",
    titulo: "San Judas 90 cm",
    descripcion: "San Judas con medidas de 90 cm de alto, hecho con fibra de vidrio y resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanjudas90cm.jpg",
  },
  {
    id: 2,
    categoria: "cat-7",
    titulo: "Pastor yeso 30 cm",
    descripcion: "Pastor de yeso incado, con medidas de 30 cm, tipo económico",
    imagen: "/catalogoimagenes/pastores/pastoryesoeco1.jpg",
  },
  {
    id: 5,
    categoria: "cat-2",
    titulo: "Angeles Custodios 30 cm",
    descripcion: "Par de angeles de resina de 30 cm con acabado fino listos para conectarse (incluye foco).",
    imagen: "/catalogoimagenes/angeles/angelcustodio30cm.jpg",
  },
  {
    id: 6,
    categoria: "cat-4",
    titulo: "Cristo 140 cm",
    descripcion: "Cristo de 1.40 cm en fibra de vidrio con resina, la cruz es de madera con medidas 170 x 90 cm.",
    imagen: "/catalogoimagenes/cristos/cristo140cm.jpg",
  },
  {
    id: 7,
    categoria: "cat-6",
    titulo: "Nacimiento Yeso 90 cm",
    descripcion: "Nacimiento de yeso de 90 cm en colores tradicionales, incluye 8 piezas (dispobible en color nacar, metálico y beige).",
    imagen: "/catalogoimagenes/nacimientos/nacimiento90cmyeso.jpg",
  },
  {
    id: 8,
    categoria: "cat-6",
    titulo: "Nacimiento barro 8 cm",
    descripcion: "Nacimiento fino de 20 piezas de 8 cm elaborado con barro.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento8cmbarro.jpg",
  },
  {
    id: 9,
    categoria: "cat-8",
    titulo: "San Benito 30 cm resina",
    descripcion: "Figura de San Benito de 30 cm en resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanbenito30cmresina.jpg",
  },
  {
    id: 10,
    categoria: "cat-8",
    titulo: "San Isidro 30 cm resina",
    descripcion: "Figura de San Isidro de 30 cm en resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanisidro30cmresina.jpg",
  },
  {
    id: 11,
    categoria: "cat-8",
    titulo: "Padre Pío 30 cm resina",
    descripcion: "Figura de Padre Pío de 30 cm en resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/padrepio30cmresina.jpg",
  },
  {
    id: 12,
    categoria: "cat-8",
    titulo: "Virgen del Carmen 30 cm resina",
    descripcion: "Figura de la Virgen del Carmen sentada de 30 cm en resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/virgencarmen30cmresina.jpg",
  },
  {
    id: 13,
    categoria: "cat-8",
    titulo: "San Juan Diego 130 cm F/R",
    descripcion: "Figura de San Juan Diego hincado, pieza de fibra de vidrio con resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanjuandiego130cmfibraresina.jpg",
  },
  {
    id: 14,
    categoria: "cat-8",
    titulo: "San Juan Diego 140 cm F/R",
    descripcion: "Figura de San Juan Diego de pie, pieza hecha de fibra de vidrio con resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanjuandiego140cmfibraresina.jpg",
  },
  {
    id: 15,
    categoria: "cat-8",
    titulo: "Virgen María 110 cm M/R",
    descripcion: "Figura de Virgen María de 110 cm articulada en codo y hombro, pieza hecha de madera y resina.",
    imagen: "/catalogoimagenes/santos/virgenmaria110cmmaderaresina.jpg",
  },
  {
    id: 16,
    categoria: "cat-8",
    titulo: "San Jose 110 cm M/R",
    descripcion: "Figura de San Jose de 110 cm articulada en codo y hombro, pieza hecha de madera y resina.",
    imagen: "/catalogoimagenes/santos/sanjose110cmmaderaresina.jpg",
  },
  {
    id: 17,
    categoria: "cat-6",
    titulo: "Nacimiento imperial 50 cm",
    descripcion: "Nacimiento de resina de 11 piezas en colores tradicionales, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientoimperial50cmresina.jpg",
  },
  {
    id: 18,
    categoria: "cat-6",
    titulo: "Nacimiento Peluche 110 cm",
    descripcion: "Nacimiento hecho de fibra de vidrio con resina, cuenta con 9 piezas pintado en colores tradicionales, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientopeluche110cmfibraresina.jpg",
  },
  {
    id: 19,
    categoria: "cat-5",
    titulo: "Cuadros 8 x 13 cm",
    descripcion: "Cuadros con medidas 8 cm x 13 cm de distindas figuras, cuadro de madera recubierto con resina (realizamos cualquier imagen).",
    imagen: "/catalogoimagenes/cuadros/cuadros8x13cm.jpg",
  },
  {
    id: 20,
    categoria: "cat-3",
    titulo: "Castada zapatilla",
    descripcion: "Cascada funcional tipo zapatilla, mide 40 cm de alto e incluye bomba de agua.",
    imagen: "/catalogoimagenes/animalesdecoracion/cascadazapatilla.jpg",
  },
  {
    id: 21,
    categoria: "cat-2",
    titulo: "Angeles 3 virtudes",
    descripcion: "Juego de Ángeles de 3 piezas de las 3 virtudes (no veo, no hablo, no esucho), hechos con resina y disponibles en dorado, plata o rosa.",
    imagen: "/catalogoimagenes/angeles/angeles3virtudesresina.jpg",
  },
  {
    id: 22,
    categoria: "cat-9",
    titulo: "Niño Dios de batita",
    descripcion: "Niño Dios con batita de distintos colores,medida de 30, hecho en resina y con brazo fijo.",
    imagen: "/catalogoimagenes/ninodios/ninodiosbatita.jpg",
  },
  {
    id: 23,
    categoria: "cat-9",
    titulo: "Niño Dios risueño",
    descripcion: "Niño Dios con manos juntas, medida de 30 cm, hecho en resina y con brazo fijo.",
    imagen: "/catalogoimagenes/ninodios/ninodiosmanosjuntas.jpg",
  },
  {
    id: 24,
    categoria: "cat-4",
    titulo: "Cristo resucitado",
    descripcion: "Cristo resucitado con manos extendidas hecho de resina de 60 cm, cruz de madera con medidas 60 x 100 cm.",
    imagen: "/catalogoimagenes/cristos/cristoresucitado.jpg",
  },
  {
    id: 25,
    categoria: "cat-2",
    titulo: "Ángeles custodios 90 cm",
    descripcion: "Par de ángeles custodios de fibra de vidrio con resina,medidas de 90 cm de alto, listos para conectarse (incluyen foco).",
    imagen: "/catalogoimagenes/angeles/angelescustodios90fibraresina.jpg",
  },
  {
    id: 26,
    categoria: "cat-3",
    titulo: "Cría de elefantes barro",
    descripcion: "Cria de elefantes con placa, hecha con barro y con medidas 20 cm, tipo fino",
    imagen: "/catalogoimagenes/animalesdecoracion/criaelefantebarro.jpg",
  },
  {
    id: 27,
    categoria: "cat-4",
    titulo: "Cristo trinitario economico",
    descripcion: "Cristo trinitario de resina con medidas 17 x 27 cm, tipo económico",
    imagen: "/catalogoimagenes/cristos/cristotrinitarioeconresina.jpg",
  },
  {
    id: 28,
    categoria: "cat-4",
    titulo: "Cristo trinitario economico cruz de madera",
    descripcion: "Cristo trinitario de resina con cruz de madera, con medidas 20 x 30 cm, tipo económico",
    imagen: "/catalogoimagenes/cristos/cristotrinitariocruzmadera.jpg",
  },
  {
    id: 29,
    categoria: "cat-4",
    titulo: "Cristo con base 25 x 45 cm",
    descripcion: "Cristo con base de resina, con medidas 25 x 45 cm, tipo fino.",
    imagen: "/catalogoimagenes/cristos/cristobaseresina2545.jpg",
  },
  {
    id: 30,
    categoria: "cat-1",
    titulo: "Taza dia de muertos",
    descripcion: "Taza con personaje representativo de dia de muertos, hecho con ceramica.",
    imagen: "/catalogoimagenes/temporada/tazamuertos1.jpg",
  },
  {
    id: 31,
    categoria: "cat-1",
    titulo: "Taza dia de muertos",
    descripcion: "Taza con personaje representativo de dia de muertos, hecho con ceramica.",
    imagen: "/catalogoimagenes/temporada/tazamuertos2.jpg",
  },
  {
    id: 32,
    categoria: "cat-1",
    titulo: "Taza dia de muertos",
    descripcion: "Taza con personaje representativo de dia de muertos, hecho con ceramica.",
    imagen: "/catalogoimagenes/temporada/tazamuertos3.jpg",
  },
  {
    id: 33,
    categoria: "cat-1",
    titulo: "Cráneo para veladora",
    descripcion: "Craneo portaveladora decorado, hecho con barro.",
    imagen: "/catalogoimagenes/temporada/craneoveladorabarro.jpg",
  },
  {
    id: 34,
    categoria: "cat-1",
    titulo: "Cráneo decorado",
    descripcion: "Craneo decorado, hecho con barro.",
    imagen: "/catalogoimagenes/temporada/craneobarro.jpg",
  },
  {
    id: 35,
    categoria: "cat-1",
    titulo: "Cráneo catrina decorado",
    descripcion: "Craneo de catrina decorado con flores, hecho con barro.",
    imagen: "/catalogoimagenes/temporada/cabezacatrinabarro.jpg",
  },
  {
    id: 36,
    categoria: "cat-1",
    titulo: "Florero catrina",
    descripcion: "Florero de catrina decorado, hecho de cerámica.",
    imagen: "/catalogoimagenes/temporada/florerocatrina.jpg",
  },
  {
    id: 37,
    categoria: "cat-1",
    titulo: "Florero Charro esqueleto",
    descripcion: "Florero de charro esquelético, hecho de cerámica.",
    imagen: "/catalogoimagenes/temporada/florerocharromuerto.jpg",
  },
  {
    id: 38,
    categoria: "cat-3",
    titulo: "Burro con carga Mediano",
    descripcion: "Burro decorado con carga, hecho con barro.",
    imagen: "/catalogoimagenes/animalesdecoracion/burrocargadomediano.jpg",
  },
  {
    id: 39,
    categoria: "cat-8",
    titulo: "Sagrada familia 100 cm",
    descripcion: "Sagrada familia con un tamaño de 100 cm de alto, hecha con fibra de vidrio y resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sagradafamilia100cm.jpg",
  },
  {
    id: 40,
    categoria: "cat-6",
    titulo: "Nacimiento 60 cm yeso",
    descripcion: "Nacimiento de yeso de 60 cm, disponible en colores metálicos, cuenta con 8 piezas, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento60cmyeso.jpg",
  },
  {
    id: 41,
    categoria: "cat-6",
    titulo: "Nacimiento 60 cm resina",
    descripcion: "Nacimiento de yeso de 60 cm, disponible en colores tradicionales y nacarado con dorado, cuenta con 11 piezas e incluye al niño Dios, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento60cmresina.jpg",
  },
  {
    id: 42,
    categoria: "cat-9",
    titulo: "Niño Dios 8 cm resina",
    descripcion: "Niño Dios de 8 cm de largo elaborado con resina, tipo fino.",
    imagen: "/catalogoimagenes/ninodios/ninodios8cmresina.jpg",
  },
  {
    id: 43,
    categoria: "cat-9",
    titulo: "Niño Dios 35 cm resina",
    descripcion: "Niño Dios de 35 cm de largo elaborado con resina, ojo tipo alemán disponible en distintos colores, brazo movible, tipo fino.",
    imagen: "/catalogoimagenes/ninodios/ninodios35cmresinamorenito.jpg",
  },
  {
    id: 44,
    categoria: "cat-9",
    titulo: "Divina Infantita resina grande",
    descripcion: "Divina infantita de resina de 50 cm de largo, elaborada con resina, brazo movible, tipo fino.",
    imagen: "/catalogoimagenes/ninodios/divinainfantagranderesina.jpg",
  },
  {
    id: 45,
    categoria: "cat-7",
    titulo: "Pastora 110 cm F/R",
    descripcion: "Pastora de fibra de vidrio con resina, altura de 110 cm, modelo cargando frutas.",
    imagen: "/catalogoimagenes/pastores/pastorfibra110cmfrutas.jpg",
  },
  {
    id: 46,
    categoria: "cat-7",
    titulo: "Pastora 110 cm F/R",
    descripcion: "Pastora de fibra de vidrio con resina, altura de 110 cm, modelo lavando.",
    imagen: "/catalogoimagenes/pastores/pastorafibra110cmlavando.jpg",
  },
  {
    id: 47,
    categoria: "cat-7",
    titulo: "Pastora 110 cm F/R",
    descripcion: "Pastora de fibra de vidrio con resina, altura de 110 cm, modelo cargando cantaros de agua.",
    imagen: "/catalogoimagenes/pastores/pastorafibra110cmcantaro.jpg",
  },
  {
    id: 48,
    categoria: "cat-6",
    titulo: "Nacimiento 160 cm F/R",
    descripcion: "Nacimiento de 160 cm de alto, elaborado con fibra de vidrio y resina, cuenta con 9 piezas, disponible en colores tradicionales o nacarado y dorado.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento160cmfibra.jpg",
  },
  {
    id: 49,
    categoria: "cat-8",
    titulo: "Virgen de Fátima 110 cm F/R",
    descripcion: "Virgen de Fátima de 110 cm de altura, elaborada con fibra de vidrio y resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/virgenfatima110cmfibraresina.jpg",
  },
  {
    id: 50,
    categoria: "cat-8",
    titulo: "Virgen María 110 cm F/R",
    descripcion: "Virgen de María de 110 cm de altura, modelo cargando al niño Jesús, elaborada con fibra de vidrio y resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/virgenmaria110cmfibraresina.jpg",
  },
  {
    id: 51,
    categoria: "cat-8",
    titulo: "San Martín Caballero 60 cm resina",
    descripcion: "San Martín Caballero con mendigo, figura de 60 cm de altura y elaborada con resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanmartincaballero60cmresina.jpg",
  },
  {
    id: 52,
    categoria: "cat-8",
    titulo: "San Judas 30 cm resina",
    descripcion: "Imagen de San Judas con una altura de 30 cm, elaborado con resina,tipo fino.",
    imagen: "/catalogoimagenes/santos/sanjudas30cmresinafino.jpg",
  },
  {
    id: 53,
    categoria: "cat-8",
    titulo: "Divino Niño 30 cm resina",
    descripcion: "Imagen de Divino Niño o de Colombia con una altura de 30 cm, elaborado con resina,tipo fino.",
    imagen: "/catalogoimagenes/santos/divinonino30cmresinafino.jpg",
  },
  {
    id: 54,
    categoria: "cat-8",
    titulo: "San Miguel 40 cm resina",
    descripcion: "Imagen de San Miguel con diablo, tiene una altura de 40 cm, elaborado con resina,tipo fino.",
    imagen: "/catalogoimagenes/santos/sanmiguel40cmresinafino.jpg",
  },
  {
    id: 55,
    categoria: "cat-8",
    titulo: "San José carpintero 30 cm resina",
    descripcion: "Imagen de San José carpintero trabajando en su taller con el niño Jesús, tiene una altura de 30 cm, elaborado con resina,tipo fino.",
    imagen: "/catalogoimagenes/santos/josecarpintero30cmresinafino.jpg",
  },
  {
    id: 56,
    categoria: "cat-8",
    titulo: "San Miguel 30 cm resina",
    descripcion: "Imagen de San Miguel con diablo, tiene una altura de 30 cm, elaborado con resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/sanmiguel30cmresinafino.jpg",
  },
  {
    id: 57,
    categoria: "cat-8",
    titulo: "Señor de la Misericordia 130 cm F/R",
    descripcion: "Imagen del Señor de la Misericordia, tiene una altura de 130 cm, elaborado con fibra de vidrio y resina, incluidos rayos de madera, tipo fino.",
    imagen: "/catalogoimagenes/santos/senormisericordia130cmfibraresina.jpg",
  },
  {
    id: 58,
    categoria: "cat-6",
    titulo: "Nacimiento metálico 110 cm resina",
    descripcion: "Nacimiento en colores tradicionales tipo metalico, tiene una altura de 110 cm, cuenta con 9 piezas, elaborado solamente con resina, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento110cmresinafino.jpg",
  },
  {
    id: 59,
    categoria: "cat-6",
    titulo: "Nacimiento 100 cm resina",
    descripcion: "Nacimiento en colores tradicionales, tiene una altura de 100 cm, cuenta con 9 piezas, elaborado solamente con resina, tipo económico.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento100cmresinaeconomico.jpg",
  },
  {
    id: 60,
    categoria: "cat-6",
    titulo: "Nacimiento arabe 110 cm F/R",
    descripcion: "Nacimiento en colores tradicionales, tiene una altura de 110 cm, cuenta con 9 piezas, elaborado con fibra de vidrio y resina, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientoarabe110cmresinafibra.jpg",
  },
  {
    id: 61,
    categoria: "cat-6",
    titulo: "Nacimiento 30 cm resina",
    descripcion: "Nacimiento en color blanco y dorado, tiene una altura de 30 cm, cuenta con 8 piezas, elaborado con resina, tipo económico.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento30cmresinaeconomico.jpg",
  },
  {
    id: 62,
    categoria: "cat-6",
    titulo: "Nacimiento Europeo 40 cm resina",
    descripcion: "Nacimiento modelo europeo, disponible en colores tradicionales y nacar/dorado, tiene una altura de 40 cm, cuenta con 11 piezas, elaborado con resina, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientoeuropeo40cmresina.jpg",
  },
  {
    id: 63,
    categoria: "cat-8",
    titulo: "Posada 50 cm resina",
    descripcion: "Posada con una altura de 50 cm, elaborado con resina, tipo economico.",
    imagen: "/catalogoimagenes/santos/posada50cmresinaeconomica.jpg",
  },
  {
    id: 64,
    categoria: "cat-8",
    titulo: "Posada 70 cm resina",
    descripcion: "Posada con una altura de 70 cm, elaborado con resina, tipo economico.",
    imagen: "/catalogoimagenes/santos/posada70cmresinaeconomica.jpg",
  },
  {
    id: 65,
    categoria: "cat-6",
    titulo: "Nacimiento metalico 30 cm resina",
    descripcion: "Nacimiento en colores tradicionales tipo metálico, tiene una altura de 30 cm, elaborado con resina, tipo economico.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento30cmmetalicoeconomico.jpg",
  },
  {
    id: 66,
    categoria: "cat-8",
    titulo: "Posada 30 cm resina",
    descripcion: "Posada con una altura de 30 cm, elaborado con resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/posada30cmresinafina.jpg",
  },
  {
    id: 67,
    categoria: "cat-6",
    titulo: "Reyes Magos para nacimiento G",
    descripcion: "Juego de 3 Reyes Magos montados en sus animales, disponibles en colores tradicionales, con una altura de 60 cm, elaborados con resina, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/reyesmagosgrandesresinafino.jpg",
  },
  {
    id: 68,
    categoria: "cat-6",
    titulo: "Reyes Magos para nacimiento M",
    descripcion: "Juego de 3 Reyes Magos montados en sus animales, disponibles en colores tradicionales, con una altura de 40 cm, elaborados con resina, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/reyesmagosmedianoresinafino.jpg",
  },
  {
    id: 69,
    categoria: "cat-6",
    titulo: "Nacimiento entintado 30 cm resina",
    descripcion: "Nacimiento entintado de 30 cm, disponibles en colores tradicionales, cuenta con 9 piezas, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientoentintado30cmresinafino.jpg",
  },
  {
    id: 70,
    categoria: "cat-8",
    titulo: "Posada 30 cm resina",
    descripcion: "Posada con una altura de 30 cm, elaborado con resina, tipo económico.",
    imagen: "/catalogoimagenes/santos/posada30cmresinaeconomica.jpg",
  },
  {
    id: 71,
    categoria: "cat-8",
    titulo: "Posada 60 cm F/R",
    descripcion: "Posada con una altura de 60 cm, elaborado con fibra de vidrio y resina, tipo fino.",
    imagen: "/catalogoimagenes/santos/posada60cmfibraresina.jpg",
  },
  {
    id: 72,
    categoria: "cat-6",
    titulo: "Nacimiento 60 cm yeso",
    descripcion: "Nacimiento de yeso de 60 cm de alto, disponible en colores tradicionales, nacar/dorado, metálico, cuenta con 8 piezas, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientocolores60cmyeso.jpg",
  },
  {
    id: 73,
    categoria: "cat-6",
    titulo: "Nacimiento 30 cm resina",
    descripcion: "Nacimiento de resina de 30 cm de alto, disponible en colores tradicionales, cuenta con 9 piezas, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientocolores30cmresinafino.jpg",
  },
  {
    id: 74,
    categoria: "cat-6",
    titulo: "Nacimiento 20 cm resina",
    descripcion: "Nacimiento de resina de 20 cm de alto, disponible en colores tradicionales, cuenta con 9 piezas, tipo económico.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento20cmresina.jpg",
  },
  {
    id: 75,
    categoria: "cat-6",
    titulo: "Nacimiento 20 cm yeso",
    descripcion: "Nacimiento de yeso de 20 cm de alto, disponible en colores tradicionales o nacar/dorado, cuenta con 8 piezas, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento20cmyeso.jpg",
  },
  {
    id: 76,
    categoria: "cat-6",
    titulo: "Nacimiento vintage 30 cm resina",
    descripcion: "Nacimiento de resina de 30 cm de alto, disponible en colores tradicionales estilo vintage, cuenta con 10 piezas, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/nacimientovintage30cmresina.jpg",
  }
  ,
  {
    id: 77,
    categoria: "cat-3",
    titulo: "Rio Mini",
    descripcion: "Rio completamente funcional de un tamaño de 40 cm de largo, incluye bomba de agua y traste decorado.",
    imagen: "/catalogoimagenes/animalesdecoracion/riomini.jpg",
  },
  {
    id: 78,
    categoria: "cat-3",
    titulo: "Rio Chico",
    descripcion: "Rio completamente funcional de un tamaño de 60 cm de largo, incluye bomba de agua y traste decorado.",
    imagen: "/catalogoimagenes/animalesdecoracion/riochico.jpg",
  },
  {
    id: 79,
    categoria: "cat-3",
    titulo: "Rio Mediano",
    descripcion: "Rio completamente funcional de un tamaño de 80 cm de largo, incluye bomba de agua y traste decorado.",
    imagen: "/catalogoimagenes/animalesdecoracion/riomediano.jpg",
  },
  {
    id: 80,
    categoria: "cat-3",
    titulo: "Rio Grande",
    descripcion: "Rio completamente funcional de un tamaño de 100 cm de largo, incluye bomba de agua y traste decorado.",
    imagen: "/catalogoimagenes/animalesdecoracion/riogrande.jpg",
  },
  {
    id: 81,
    categoria: "cat-3",
    titulo: "Rio Extra Grande",
    descripcion: "Rio completamente funcional de un tamaño de 120 cm de largo, incluye bomba de agua y traste decorado.",
    imagen: "/catalogoimagenes/animalesdecoracion/rioextra.jpg",
  },
  {
    id: 82,
    categoria: "cat-3",
    titulo: "Borrego resina mini",
    descripcion: "Borregos de resina en distintas formas, con un tamaño de 10 cm de alto, tipo económico.",
    imagen: "/catalogoimagenes/animalesdecoracion/borregoresina10cm.jpg",
  },
  {
    id: 83,
    categoria: "cat-3",
    titulo: "Vacas yeso",
    descripcion: "Vacas de yeso en distintas formas, perfectas para un nacimiento de 20 a 30 cm, tipo económico.",
    imagen: "/catalogoimagenes/animalesdecoracion/vacasyeso30cm.jpg",
  },
  {
    id: 84,
    categoria: "cat-3",
    titulo: "Animales de granja yeso",
    descripcion: "Gallo, puerco, gallina y guajolote de yeso, disponibles en distintos colores, perfectas para un nacimiento de 15 a 30 cm, tipo económico.",
    imagen: "/catalogoimagenes/animalesdecoracion/animalesgranja15cmyeso.jpg",
  },
  {
    id: 85,
    categoria: "cat-3",
    titulo: "Casas 2 pisos yeso",
    descripcion: "Modelos de casa de 2 pisos de yeso, disponibles en distintos colores, perfectas para un nacimiento de 20 a 30 cm, tipo económico.",
    imagen: "/catalogoimagenes/animalesdecoracion/casas2pisos30cmyeso.jpg",
  },
  {
    id: 86,
    categoria: "cat-3",
    titulo: "Casas 1 piso yeso",
    descripcion: "Modelos de casa de 1 piso de yeso, disponibles en distintos colores, perfectas para un nacimiento de 20 a 30 cm, tipo económico.",
    imagen: "/catalogoimagenes/animalesdecoracion/casas1piso30cmyeso.jpg",
  },
  {
    id: 87,
    categoria: "cat-3",
    titulo: "Corrales",
    descripcion: "Corrales con distintos animales como gallos, conejos o guajolotes, perfectos para un nacimiento de 15 a 40 cm, tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/corrales.jpg",
  },
  {
    id: 88,
    categoria: "cat-3",
    titulo: "Arboles frutales",
    descripcion: "Arboles con distintos tipos de fruta con base de madera, cada arbol mide aproximadamente 40 cm de alto.",
    imagen: "/catalogoimagenes/animalesdecoracion/arbolesfrutales.jpg",
  },
  {
    id: 89,
    categoria: "cat-3",
    titulo: "Pozo Barro M",
    descripcion: "Pozo con teja elaborado con barro, disponible en distintos colores, cada pozo mide aproximadamente 25 cm de alto, tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/pozo30cmbarrofino.jpg",
  },
  {
    id: 90,
    categoria: "cat-3",
    titulo: "Pozo Barro G",
    descripcion: "Pozo con teja elaborado con barro, disponible en distintos colores, cada pozo mide aproximadamente 35 cm de alto,tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/pozo45cmbarrofino.jpg",
  },
  {
    id: 91,
    categoria: "cat-3",
    titulo: "Ordeñador grande 20 cm",
    descripcion: "Juego de ordeñador de 4 piezas de aproximadamente 20 cm de alto, incluye: vaca, becerro, bote y ordeñador,tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/ordenadorgrandebarro.jpg",
  },
  {
    id: 92,
    categoria: "cat-3",
    titulo: "Ordeñador chico 15 cm",
    descripcion: "Juego de ordeñador de 4 piezas de aproximadamente 15 cm de alto, incluye: vaca, becerro, bote y ordeñador,tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/ordenadorchicobarro.jpg",
  },
  {
    id: 93,
    categoria: "cat-3",
    titulo: "Lago de barro 25 a 30 cm",
    descripcion: "Lago de barro de una sola pieza, con una altura de aproximadamente 25 a 30 cm, tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/lagobarrofino.jpg",
  },
  {
    id: 94,
    categoria: "cat-3",
    titulo: "Pavo resina 20 cm",
    descripcion: "Pavo de resina de aproximadamente 20 cm de alto, tipo económico.",
    imagen: "/catalogoimagenes/animalesdecoracion/guajoloteresina20cmeconomico.jpg",
  },
  {
    id: 95,
    categoria: "cat-3",
    titulo: "Borrego yeso 30 cm",
    descripcion: "Borrego de yeso de aproximadamente 30 cm de alto, disponible con cuerno y sin cuerno en distintas poses, tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/borregoyeso30cm.jpg",
  },
  {
    id: 96,
    categoria: "cat-3",
    titulo: "Pato yeso 60 cm",
    descripcion: "Pato de yeso de aproximadamente 60 cm de alto.",
    imagen: "/catalogoimagenes/animalesdecoracion/patoyesogrande.jpg",
  },
  {
    id: 97,
    categoria: "cat-3",
    titulo: "Carreta de barro 20 cm",
    descripcion: "Carreta que consta de 3 piezas, arriero, animal de carga y carreta, mide aproximadamente 20 cm de alto.",
    imagen: "/catalogoimagenes/animalesdecoracion/carretabarro.jpg",
  },
  {
    id: 98,
    categoria: "cat-3",
    titulo: "Yunta de barro 20 cm",
    descripcion: "Yunta que consta de 4 piezas, arriero, 2 animal de carga y carreta, mide aproximadamente 20 cm de alto.",
    imagen: "/catalogoimagenes/animalesdecoracion/yuntabarro.jpg",
  },
  {
    id: 99,
    categoria: "cat-3",
    titulo: "Gallo y Gallina resina",
    descripcion: "Gallo y gallina elaborado con resina, mide aproximadamente 50 cm y 40 cm respectivamente, disponibles en distintos colores, tipo fino.",
    imagen: "/catalogoimagenes/animalesdecoracion/gallogallinaresina.jpg",
  },
  {
    id: 100,
    categoria: "cat-3",
    titulo: "Gallina con nido 20 cm",
    descripcion: "Gallina echada con nido y huevo elaborados con yeso, disponible en distintos colores, aproximadamente 20 cm de alto.",
    imagen: "/catalogoimagenes/animalesdecoracion/nidogallinayeso.jpg",
  },
  {
    id: 101,
    categoria: "cat-3",
    titulo: "Pozo yeso 35 cm",
    descripcion: "Pozo de yeso sin teja, aproximadamente 35 cm de alto, disponible en varios colores, tipo economico.",
    imagen: "/catalogoimagenes/animalesdecoracion/pozoyesoeconomico.jpg",
  },
  {
    id: 102,
    categoria: "cat-3",
    titulo: "Borrego resina 15 cm",
    descripcion: "Borrego de resina de 15 cm de alto.",
    imagen: "/catalogoimagenes/animalesdecoracion/borregoresina15cm.jpg",
  },
  {
    id: 103,
    categoria: "cat-7",
    titulo: "Pastor yeso 20 cm",
    descripcion: "Pastor y pastora de yeso en diferentes poses y modelos, miden aproximadamente 20 cm de altura.",
    imagen: "/catalogoimagenes/pastores/pastoresyeso20cm.jpg",
  },
  {
    id: 104,
    categoria: "cat-7",
    titulo: "Pastor yeso 20 cm",
    descripcion: "Pastor y pastora de yeso en diferentes poses y modelos, miden aproximadamente 20 cm de altura.",
    imagen: "/catalogoimagenes/pastores/pastoryeso20cm2.jpg",
  },
  {
    id: 105,
    categoria: "cat-8",
    titulo: "Posada 20 cm resina",
    descripcion: "Posada con una altura de 20 cm, elaborado con resina, tipo economico.",
    imagen: "/catalogoimagenes/santos/posada20cmresinaeconomica.jpg",
  },
  {
    id: 106,
    categoria: "cat-6",
    titulo: "Reyes Magos para nacimiento Ch",
    descripcion: "Juego de 3 Reyes Magos montados en sus animales, disponibles en colores tradicionales, con una altura de 30 cm, elaborados con resina, tipo fino.",
    imagen: "/catalogoimagenes/nacimientos/reyesmagoschicofino.jpg",
  },
  {
    id: 107,
    categoria: "cat-6",
    titulo: "Reyes Magos para nacimiento yeso",
    descripcion: "Juego de 3 Reyes Magos montados en sus animales, disponibles en colores tradicionales, con una altura de 30 cm, elaborados con yeso.",
    imagen: "/catalogoimagenes/nacimientos/reyesmagoyesochico.jpg",
  },
  {
    id: 108,
    categoria: "cat-6",
    titulo: "Reyes Magos para nacimiento Ch económico",
    descripcion: "Juego de 3 Reyes Magos montados en sus animales, disponibles en colores tradicionales, con una altura de 30 cm, elaborados con resina, tipo economico.",
    imagen: "/catalogoimagenes/nacimientos/reyesmagoschicoeconomico.jpg",
  },
  {
    id: 109,
    categoria: "cat-6",
    titulo: "Nacimiento resina 15 cm",
    descripcion: "Nacimiento de resina de 15 cm de alto, disponible en colores tradicionales, cuenta con 9 piezas.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento15cmresina.jpg",
  },
  {
    id: 110,
    categoria: "cat-6",
    titulo: "Nacimiento resina 20 cm flaco",
    descripcion: "Nacimiento de resina de 20 cm de alto, disponible en colores tradicionales, cuenta con 10 piezas modelo tipo flaco.",
    imagen: "/catalogoimagenes/nacimientos/nacimiento20cmresinaalto.jpg",
  },
  {
    id: 111,
    categoria: "cat-6",
    titulo: "Nacimiento linterna color yeso",
    descripcion: "Nacimiento de yeso modelo linterna con 8 piezas, mide aproximadamente 15 cm de alto, disponible en colores tradicionales y blanco/dorado.",
    imagen: "/catalogoimagenes/nacimientos/nacimientolinternacolor.jpg",
  },
  {
    id: 112,
    categoria: "cat-6",
    titulo: "Nacimiento linterna blanco yeso",
    descripcion: "Nacimiento de yeso modelo linterna con 8 piezas, mide aproximadamente 15 cm de alto, disponible en colores tradicionales y blanco/dorado.",
    imagen: "/catalogoimagenes/nacimientos/nacimientolinternablanco.jpg",
  },
  {
    id: 113,
    categoria: "cat-6",
    titulo: "Nacimiento de niños resina",
    descripcion: "Nacimiento modelo de niños, elaborado con resina de aproximadamente 10 cm de altura, cuenta con 10 piezas, disponible en colores tradicionales.",
    imagen: "/catalogoimagenes/nacimientos/nacimientoninocolor.jpg",
  },
  {
    id: 114,
    categoria: "cat-6",
    titulo: "Nacimiento de caricatura resina",
    descripcion: "Nacimiento modelo caricatura, elaborado con resina de aproximadamente 15 cm de altura, cuenta con 9 piezas, disponible en colores tradicionales.",
    imagen: "/catalogoimagenes/nacimientos/nacimientocaricaturaresinacolor.jpg",
  },
  {
    id: 115,
    categoria: "cat-1",
    titulo: "Reno de yeso",
    descripcion: "Reno de yeso de aproximadamente 90 cm de alto, disponible en distintos colores.",
    imagen: "/catalogoimagenes/temporada/renoyeso.jpg",
  },
  {
    id: 116,
    categoria: "cat-1",
    titulo: "Muñeco de nieve de yeso",
    descripcion: "Muñeco de nieve elaborado con yeso de aproximadamente 90 cm de alto, disponible en distintos colores.",
    imagen: "/catalogoimagenes/temporada/muneconieveyeso.jpg",
  },
  {
    id: 117,
    categoria: "cat-1",
    titulo: "Muñeco de nieve de ceramica",
    descripcion: "Muñeco de nieve elaborado con ceramica de aproximadamente 45 cm de alto.",
    imagen: "/catalogoimagenes/temporada/muneconieveceramica.jpg",
  }
  
  

];

export default productos;